import { Reducer } from 'redux';
import { IReduxAction } from 'app/types/actions';
import { AuthenticationActionTypes } from 'app/ducks/authentication/types';
import { OnBoardingActionTypes as types, IOnBoardingState } from './types';

const initialState: IOnBoardingState = {
  inFlightUser: {
    email: '',
    fullName: '',
    password: '',
    mobile: '',
    organisation: {
      organisationId: '',
      selectedSport: undefined,
      organisationName: '',
    },
    account: {
      name: '',
      bsb: '',
      number: '',
      bank: '',
    },
    teamShare: {
      amount: '',
      payTo: '',
    },
    jwtToken: null,
  },
  sports: [],
  hasUserLoggedIn: false,
  hasUserCreated: false,
  verificationSuccessful: false,
  awaitingUserVerification: false,
  backendErrors: {},
};

const reducer: Reducer<IOnBoardingState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.PERSIST_HYDRATED:
      return {
        ...state,
        ...action?.payload?.onBoarding,
        rehydrated: true,
      };
    case types.LOAD_GET_STARTED:
      return initialState;
    case types.GET_SPORTS_SUCCESS:
      return {
        ...state,
        sports: action.payload.sports,
      };
    case types.CREATE_NEW_USER_REQUESTED:
      return {
        ...state,
        backendErrors: {},
        isLoading: true,
        hasLoaded: false,
      };
    case types.UPDATE_ADMIN_DATA:
      return {
        ...state,
        inFlightUser: {
          ...state.inFlightUser,
          ...action.payload,
        },
      };
    case types.USER_CREATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        awaitingUserVerification: true,
        backendErrors: {},
      };
    case types.USER_CREATION_FAILED:
      return {
        ...state,
        backendErrors: action.payload.backendErrors,
        isLoading: false,
        awaitingUserVerification: true,
      };
    case types.BANK_ACCOUNT_CREATION_FAILED:
      return {
        ...state,
        isLoading: false,
        backendErrors: action.payload.backendErrors,
      };
    case types.VERIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        awaitingUserVerification: false,
        verificationSuccessful: true,
        inFlightUser: {
          ...state.inFlightUser,
          password: '',
        },
        backendErrors: {},
      };
    case types.VERIFICATION_FAILED:
      return {
        ...state,
        isLoading: false,
        hasFailed: true,
        awaitingUserVerification: false,
        failedVerification: true,
        backendErrors: action.payload.backendErrors,
      };
    case types.OPERATION_PENDING:
      return {
        ...state,
        isLoading: true,
        hasLoaded: false,
        hasFailed: false,
      };
    case types.OPERATION_FINISHED:
      return {
        ...state,
        isLoading: false,
      };
    case AuthenticationActionTypes.AUTHENTICATE_COGNITO_USER_SUCCESS:
      return {
        ...state,
        hasUserLoggedIn: true,
        isLoading: false,
        inFlightUser: {
          ...state.inFlightUser,
          jwtToken: action.payload.accessToken.jwtToken,
        },
      };
    case types.USER_CREATE_TEAM_SUCCESS:
      return {
        ...state,
        inFlightUser: {
          ...state.inFlightUser,
          team: action.payload,
        },
      };
    case types.USER_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasUserCreated: true,
      };
    case types.USER_LOGIN_FAILED:
      return {
        ...state,
        loginError: 'something went wrong',
      };
    case types.CONTINUE_TO_DASHBOARD:
      return {
        ...state,
        continueToDashboard: true,
      };
    case types.RESET_ONBOARDING:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
